<div class="component-search-container">
  <input class="vox-text-field"
    name="company-search"
    type="text"
    [(ngModel)]="company"
    (ngModelChange)="onModelChange($event)"
    (selectItem)="companySelected($event)"
    [ngbTypeahead]="companySearch"
    [resultTemplate]="companyTemplate"
    [inputFormatter]="resultFormatter"
    [editable]="false"
    [disabled]="disabled"/>

  <i class="vox-text-field__icon vox-text-field__icon_valid ladda"
    [class.ladda-show]="searching"
    [ladda]="searching"
    data-spinner-color="grey"
    data-style="zoom-in"></i>
  <span class="vox-input-group__error-message"
    [style.display]="isListEmpty ? 'block': 'none'"
    translate>
    company-search.empty
  </span>

  <ng-template #companyTemplate let-r="result" let-t="term">
    <table class="container company-search-result">
      <tr>
        <td translate>company-search.result.name</td>
        <td class="text-right font-weight-bold">{{r.name}}</td>
      </tr>
      <tr>
        <td translate>company-search.result.alphaname</td>
        <td class="text-right font-weight-bold">{{r.alphaname}}</td>
      </tr>
      <tr>
        <td translate>company-search.result.email</td>
        <td class="text-right font-weight-bold">{{r.email}}</td>
      </tr>
    </table>
  </ng-template>
</div>
